import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles<Theme>((theme: Theme) => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
      paddingLeft: '158px',
      width: '100%',
      backgroundColor: theme.palette.background.default,
    },
    title: {
      marginTop: '45px',
      marginBottom: '28px',
      textAlign: 'center',
    },
    p: {
      marginTop: '10px',
      marginBottom: '28px',
      opacity: '70%',
      textAlign: 'center',
    },
    submitButton: {
      display: 'block',
      marginTop: '10px',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    form: {
      width: '398px',
      height: '367px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'spaceEvenly',
      alignItems: 'center',
      paddingRight: '34px',
      paddingLeft: '34px',
      paddingBottom: '48px',
      backgroundColor: theme.palette.background.paper,
      borderRadius: '12px',
    },
    successContainer: {
      width: '398px',
      height: '280px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'spaceEvenly',
      alignItems: 'center',
      paddingRight: '34px',
      paddingLeft: '34px',
      paddingBottom: '48px',
      backgroundColor: theme.palette.background.paper,
      borderRadius: '12px',
    },
    formElements: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-around',
    },
    akomiPage: {
      height: '100vh',
      width: '100%',
      display: 'flex',
    },
    akomiLogo: {
      backgroundColor: theme.palette.background.paper,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      width: '100%',
    },
    resetPasswordForm: {
      height: '100%',
      width: '100%',
      backgroundColor: theme.palette.background.default,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  };
});

export default useStyles;
